import React, {useState} from 'react'
import FieldDropdown from '../FieldDropdown'
import VisDiv from '../frontend_components/VisDiv'
import { useQuery } from '@tanstack/react-query'
import { _FETCH } from '../../lib/patches'
import { registersQuery } from '../../lib/data'
import { addValueForDropdown, sortByLabel, successAlert, siteName } from '../../lib/utils'
import NonConformityPin from '../NonConformityPin'
import { useCreateReplace } from '../../hooks/mutations'
import { useQueryClient } from '@tanstack/react-query'
import { useStateContext } from '../../context/StateContext'
import Loading from '../Loading'
import { useAuthContext } from '../../hooks/useAuthContext'

/**
 * MigrazionePresidi component
 * 
 * @param {Object} data - an object containing the necessary data for the component, 
 * @param {Object} data.sites - an array of site objects
 * @param {Object} data.client - a client object
 * @param {Object} data.clients - an array of client objects
 * @param {Object} data.templateRegisters - an array of template register objects
 * #registerManagement
 * @returns {JSX.Element} - a JSX element representing the MigrazionePresidi component
 */
const MigrazionePresidi = ({data={}}) => {
    const [loading, setLoading] = useState(false)
    const {sites, client, clients, templateRegisters} = data
    const clientSites = !Array.isArray(sites) ? [] : sites?.filter?.((x)=>x?.client?._ref == client?._id )?.map?.((item)=>({...item, value: item?.label}))
    const {apiUrl} = useStateContext()
    const fetchRoute = `${apiUrl}/calls/fetch-docs`
    const {user} = useAuthContext()
    const [site, setSite] = useState();
    const [initialSourceRegister, setinitialSourceRegister] = useState();
    const [initialTargetRegister, setinitialTargetRegister] = useState();


    const [sourceRegister, setSourceRegister] = useState();
    const [targetRegister, setTargetRegister] = useState();


    const [registers, setRegisters] = useState([]);
    const [devicesToTransfer, setDevicesToTransfer] = useState([]);

    const registerLabelAndName = (register) => {
        if(register?.registerName) {return `${register?.label} ${register?.registerName}`}
        return register?.label
    }
    const registersOptions = registers?.length < 1 ? [] : registers?.map?.((register)=>{return({...register, label: registerLabelAndName(register), value: registerLabelAndName(register)})})  

    const {data: registersData, isLoading: registersDataLoading} = useQuery(['registersTransfer', site], ()=>_FETCH({route: fetchRoute, user, query: registersQuery(site._id, "ATTIVO")}),{
        enabled: !! site,
        onSuccess: (data)=>{
            console.log("registers loaded", data);
            setRegisters(data);  
        },
        onError:(error)=>{console.log("registers not loaded", error)},
    })
    const queryClient = useQueryClient()
    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['registersTransfer', site] })
            const previousData = queryClient.getQueryData(['registersTransfer', site])
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['registersTransfer', site], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData}
        },

        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            setLoading(false)
            errorAlert("ERRORE; RICARICA LA PAGINA")
            
            
            //queryClient.setQueryData(['customerProducts'], context?.previousData)

        }
        })
    const sourceRegisterOriginal = !Array.isArray(registers) ? {} : registers?.find?.((x)=>x?._id == sourceRegister?._id)
    const sourceRegisterOriginalDevices = sourceRegisterOriginal?.devices?.length < 1 ? [] : sourceRegisterOriginal?.devices

    const targetRegisterOriginal = !Array.isArray(registers) ? undefined : registers?.find?.((x)=>x?._id == targetRegister?._id)
    const targetRegisterOriginalDevices = targetRegisterOriginal?.devices?.length < 1 ? [] : targetRegisterOriginal?.devices


    const devicesWithNewRegister = devicesToTransfer?.length < 1 ? [] : devicesToTransfer?.map?.((item)=>({...item, register: {...item?.register, _ref:targetRegisterOriginal?._id}}))

    const newSourceRegisterDoc = !sourceRegisterOriginal ? {} : {
        ...sourceRegisterOriginal, devices: [...sourceRegisterOriginalDevices?.filter?.((x)=> !devicesWithNewRegister?.some?.((y)=> y?._id == x?._id))]
    }
    const newTargetRegisterDoc = !targetRegisterOriginal ? {} : {
        ...targetRegisterOriginal, devices: [...targetRegisterOriginalDevices, ...devicesWithNewRegister]
    } 

    const migrate = async () => {
        setLoading(true)
        console.log("NEW SOURCE", newSourceRegisterDoc)
        console.log("NEW TARGET", newTargetRegisterDoc)
        updateDocument({doc:newSourceRegisterDoc},{onSuccess:(doc) => { 
            console.log("SOURCE SUCCEESSSSS", doc); 
            updateDocument({doc:newTargetRegisterDoc},{onSuccess:(doc1) => {
                console.log("TARGET SUCCEESSSSS", doc1); 
                setDevicesToTransfer([])
                setSourceRegister(undefined)
                setTargetRegister(undefined)
                setinitialSourceRegister({})
                setinitialTargetRegister({})
                setLoading(false)
                }})
        }
        }
        )



    }
    
    const targetTemplateRegister = !Array.isArray(templateRegisters) ? undefined : templateRegisters?.find?.((x)=>x?._id == targetRegister?.template?._ref)
    const deviceTemplatesInTargetRegister = sourceRegister?.devices?.filter?.((x)=>targetTemplateRegister?.devices?.some?.((y)=>y?._ref == x?.templateDevice?._ref)) 
    const testFunction = () => {
        console.log("filter", sourceRegister?.devices?.filter?.((x)=>targetTemplateRegister?.devices?.some?.((y)=>y?._ref == x?.templateDevice?._ref)), targetTemplateRegister );
    }
 
  if(!client) return <div><h3>SELEZIONA CLIENTE</h3></div>
  return (
    <div>
        <VisDiv rules={[loading]}><Loading/></VisDiv>
        <button onClick={testFunction}>TEST Migrazione Presidi</button>
        <FieldDropdown
            isSearchable="isSearchable"
            options={clientSites}
            placeHolder={"SELEZIONA PLESSO"}
            onChange={(value)=>{setSite({...value, label: siteName(value), value: siteName(value)})}} 
        />
        <VisDiv rules={[site]}>
            <h4>REGISTRO ORIGINE</h4>
            <FieldDropdown
                isSearchable="isSearchable"
                initialValue={initialSourceRegister}
                options={registersOptions}
                placeHolder={"SELEZIONA REGISTRO ORIGINE"}
                onChange={(value)=>{setSourceRegister(value)}}
            />
              <h4>REGISTRO DESTINAZIONE</h4>
            <FieldDropdown
                isSearchable="isSearchable"
                initialValue={initialTargetRegister}
                options={registersOptions}
                placeHolder={"SELEZIONA REGISTRO DESTINAZIONE"}
                onChange={(value)=>{setTargetRegister(value)}}
            />
        </VisDiv>
        <VisDiv rules={[sourceRegister, targetRegister]}>
            <h4 style={{marginBottom:"10px"}}> SELEZIONA I PRESIDI DA MIGRARE: </h4>
            {deviceTemplatesInTargetRegister?.sort(sortByLabel)?.map?.((item) => {
                const isItemInArray = devicesToTransfer?.some?.((x=>x?._id == item?._id))
                return (<NonConformityPin
                    key={item?._id}
                    label={item?.label}
                    initialValue = {isItemInArray}
                    item={item}
                    array={devicesToTransfer}
                    setArray={setDevicesToTransfer}
                />)
            })}
        </VisDiv>
        <VisDiv rules={[devicesToTransfer?.length > 0]}className='bottom-buttons'>
             <button type="button" style={{backgroundColor: "green"}} className="btn" onClick={()=>migrate()}>{"MIGRA PRESIDI"}</button>
        </VisDiv>
    </div>
  )
}

export default MigrazionePresidi
